import { render, staticRenderFns } from "./AdministratorForma.vue?vue&type=template&id=a7b34eb6&scoped=true&"
import script from "./AdministratorForma.vue?vue&type=script&lang=js&"
export * from "./AdministratorForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b34eb6",
  null
  
)

export default component.exports